<div class="container-session-summary">
    <mat-card class="summary-card">
      <mat-card-header>
        <mat-card-title>Overall Summary</mat-card-title>
        <div class="dashboard-header-filters">
          <mat-form-field appearance="outline" class="time-range-select">
            <mat-label>Time Range</mat-label>
            <mat-select panelClass="um-select-panel" [(ngModel)]="timeRange" (selectionChange)="onTimeRangeChange($event)">
              <mat-option value="day">Day</mat-option>
              <mat-option value="week">Week</mat-option>
              <mat-option value="month">Month</mat-option>
              <mat-option value="custom">Custom</mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngIf="timeRange === 'custom'">
            <mat-form-field appearance="outline" class="custom-date-field">
              <input matInput [owlDateTime]="startPicker" [owlDateTimeTrigger]="startPicker" placeholder="Start Date" [(ngModel)]="startDate" (dateTimeChange)="onCustomDateChange()">
              <mat-datepicker-toggle matSuffix [for]="$any(startPicker)"></mat-datepicker-toggle>
              <owl-date-time #startPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
            </mat-form-field>
            <mat-form-field appearance="outline" class="custom-date-field">
              <input matInput [owlDateTime]="endPicker" [owlDateTimeTrigger]="endPicker" placeholder="End Date" [(ngModel)]="endDate" (dateTimeChange)="onCustomDateChange()">
              <mat-datepicker-toggle matSuffix [for]="$any(endPicker)"></mat-datepicker-toggle>
              <owl-date-time #endPicker [pickerType]="'both'" [showSecondsTimer]="true"></owl-date-time>
            </mat-form-field>
          </ng-container>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="summary-container">
            <div class="mat-table-container um-table-wrap">
                <mat-table [dataSource]="dataSource" class="mat-table um-table">
                    <ng-container matColumnDef="category">
                        <mat-header-cell *matHeaderCellDef class="left-sorted-header"> Category </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="left-sorted-header">{{ row.category }}</mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="totalCount">
                        <mat-header-cell *matHeaderCellDef class="centered-sorted-header"> Total Count </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="centered-sorted-header">
                          <div  *ngIf="!row.split"><a href="javascript:void(0)" (click)="routeToSessionPage(row)">{{ row.totalCount }}</a> </div> 
                          <div  *ngIf="row.split == 'true'">
                            <span>{{row?.data?.total}} | web:{{row?.data?.web}} </span>
                            <span>| android:{{row?.data?.android}} | ios:{{row?.data?.ios}}</span>
                          </div> 
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="uniqueCount">
                        <mat-header-cell *matHeaderCellDef class="centered-sorted-header"> Unique Count </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="centered-sorted-header"> {{ row.uniqueCount }} </mat-cell>
                    </ng-container>
    
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row"></mat-row>
                </mat-table>
            </div>
        </div>
    </mat-card-content>
    
    </mat-card>
    <mat-card class="summary-card">
      <mat-card-header>
        <div class="header-content">
          <mat-card-title style="margin-top: 10px;">Instant Summary (^30 mins)</mat-card-title>
          <mat-icon class="refresh-icon" (click)="applyFilter()" color="primary">refresh</mat-icon>
        </div>
        <!-- <mat-card-title>Instant Summary</mat-card-title> -->
        <!-- <mat-form-field appearance="outline" class="time-range-select">
          <mat-label>Time Range</mat-label>
          <mat-select panelClass="um-select-panel" [(ngModel)]="timeRange" (selectionChange)="onTimeRangeChange()">
            <mat-option value="day">Day</mat-option>
            <mat-option value="week">Week</mat-option>
            <mat-option value="month">Month</mat-option>
          </mat-select>
        </mat-form-field> -->
      </mat-card-header>
      <mat-card-content>
        <div class="summary-container">
          <div class="mat-table-container um-table-wrap">
              <mat-table [dataSource]="instantDS" class="mat-table um-table">
                  <ng-container matColumnDef="category">
                      <mat-header-cell *matHeaderCellDef class="left-sorted-header"> Category </mat-header-cell>
                      <mat-cell *matCellDef="let row" class="left-sorted-header">{{ row.category }}</mat-cell>
                  </ng-container>
  
                  <ng-container matColumnDef="totalCount">
                      <mat-header-cell *matHeaderCellDef class="centered-sorted-header"> Total Count </mat-header-cell>
                      <mat-cell *matCellDef="let row" class="centered-sorted-header">
                        <div  *ngIf="!row.split"> {{ row.totalCount }} </div> 
                        <div  *ngIf="row.split == 'true'">
                          <span>{{row?.data?.total}} | web:{{row?.data?.web}} </span>
                          <span>| android:{{row?.data?.android}} | ios:{{row?.data?.ios}}</span>
                        </div> 
                      </mat-cell>
                  </ng-container>
  
                  <ng-container matColumnDef="uniqueCount">
                      <mat-header-cell *matHeaderCellDef class="centered-sorted-header"> Unique Count </mat-header-cell>
                      <mat-cell *matCellDef="let row" class="centered-sorted-header"> {{ row.uniqueCount }} </mat-cell>
                  </ng-container>
  
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row"></mat-row>
              </mat-table>
          </div>
      </div>
        <!-- <div class="summary-container">
          <div class="summary-item">
            <p>Active Users:</p>
            <span>{{ activeUsers }}</span>
          </div>
          <div class="summary-item">
            <p>Unique Users:</p>
            <span>{{ activeUniqueUsernames }}</span>
          </div>
          <div class="summary-item">
            <p>Internal Users:</p>
            <span>{{ internalUsers }}</span>
          </div>
          <div class="summary-item">
            <p>External Users:</p>
            <span>{{ externalUsers }}</span>
          </div>
        </div> -->
      </mat-card-content>
    </mat-card>
  </div>
  